import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";

export const CascadeFailed = () => {
    const { t } = usePaldockTranslation("ui.cascade");
    return (
        <div className="flex flex-col items-center gap-6 px-4 font-['Poppins',sans-serif]">
            <div className="flex h-24 w-24 items-center justify-center rounded-full bg-gradient-to-b from-[#6fdc97] to-[#34b86a] shadow-[0_0_40px_10px_rgba(74,200,120,0.35)]">
                <svg
                    aria-hidden="true"
                    className="h-12 w-12 text-white"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M5 12.5l4.5 4.5L19 7.5" />
                </svg>
            </div>
            <h1 className="m-0 text-center text-2xl font-extrabold text-[#222]">
                {t("content.thank_you_request_contact")}
            </h1>
        </div>
    );
};
